import React, { useEffect, useState } from 'react';
import FsLightbox from 'fslightbox-react';
import './fs.css';
import { title } from 'process';
function FsImageOpner({
  pics,
  index,
  show,
  isDownload,
}: {
  pics: any;
  index: any;
  show: boolean;
  isDownload?: boolean;
}) {
  // const handleDownload = () => {
  //   const currentImage = pics[slide - 1];
  //   const link = document.createElement('a');
  //   link.href = currentImage;
  //   link.download = currentImage.split('/').pop(); // optional: custom filename
  //   document.body.appendChild(link);
  //   link.click();
  //   document.body.removeChild(link);
  // };

  return (
    <>
      <FsLightbox
        toggler={show}
        sources={pics}
        sourceIndex={index}
        // customToolbarButtons={[
        //   {
        //     viewBox: '0 0 16 16',
        //     d: 'M0 14h16v2h-16v-2z M8 13l5-5h-3v-8h-4v8h-3z',
        //     width: '16px',
        //     height: '16px',
        //     title: 'Download',
        //     onClick: function (instance) {
        //       var URL = instance.props.sources[instance.stageIndexes.current];
        //       var a = document.createElement('a');
        //       a.href = URL;
        //       a.setAttribute('download', '');
        //       document.body.appendChild(a);
        //       a.click();
        //       document.body.removeChild(a);
        //     },
        //   },
        // ]}
      />
      {/* {isDownload && (
        <button
          // onClick={handleDownload}
          style={{ position: 'absolute', top: 20, right: 20, zIndex: 9999 }}
        >
          Download
        </button>
      )} */}
    </>
  );
}

export default FsImageOpner;
